import { ListSubheader, ListSubheaderProps } from '@mui/material';
import { forwardRef, ReactNode } from 'react';

type Props = Omit<ListSubheaderProps, 'children'> & {
  isFirst?: boolean;
  children?: ReactNode;
};

export const QcsDropdownListSubheader = forwardRef<HTMLLIElement, Props>(
  ({ isFirst, sx, children, ...rest }, ref) => (
    <ListSubheader
      ref={ref}
      disableSticky
      {...rest}
      sx={[
        {
          mt: isFirst ? 0 : 0.5,
          mx: 1.5,
          px: 0,
          pt: isFirst ? 1 : 1.25,
          pb: 0.5,
          lineHeight: 1.4,
          fontSize: '0.6875rem',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: 'text.disabled',
          bgcolor: 'transparent',
          borderTop: isFirst ? 'none' : '1px solid',
          borderColor: 'divider',
          pointerEvents: 'none',
          userSelect: 'none',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </ListSubheader>
  ),
);

QcsDropdownListSubheader.displayName = 'QcsDropdownListSubheader';
